import React from 'react';
import { DollarSign, Users, Zap, Wallet, TrendingUp, Activity } from 'lucide-react';
import './AdminStatCard.css';

const AdminStatCard = ({ title, value, icon, color = "text-primary" }) => {
  // Mapeo de iconos para poder pasar solo un string si queremos
  const icons = {
    dollar: <DollarSign />,
    users: <Users />,
    zap: <Zap />,
    wallet: <Wallet />,
    trend: <TrendingUp />,
    activity: <Activity />
  };

  const iconElement = typeof icon === 'string' ? icons[icon] : icon;

  return (
    <div className="ad-card ad-kpi">
      <div className={`ad-kpi-icon`} style={{ color: color }}>
        {iconElement}
      </div>
      <div className="ad-kpi-info">
        <h3>{title}</h3>
        <p style={{ color: color }}>{value}</p>
      </div>
    </div>
  );
};

export default AdminStatCard;